import { render, staticRenderFns } from "./RefundDeliver.vue?vue&type=template&id=1d8eb88e&"
import script from "./RefundDeliver.vue?vue&type=script&lang=js&"
export * from "./RefundDeliver.vue?vue&type=script&lang=js&"
import style0 from "./RefundDeliver.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports